import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TCityDB, TCountryDB, TStateDB } from "models/app";

type Region = {
  countries: TCountryDB[];
  states: TStateDB[];
  cities: TCityDB[];
};

type TPageTitle = {
  title: string;
};

interface AppState {
  isPending: boolean;
  regionData: Region;
  pageTitle?: string;
}

const initialState: AppState = {
  isPending: false,
  pageTitle: "",
  regionData: {
    cities: [],
    countries: [],
    states: [],
  },
};

export const appSlide = createSlice({
  initialState,
  name: "app",
  reducers: {
    endProcess: (state) => {
      state.isPending = false;
    },
    startProcess: (state) => {
      state.isPending = true;
    },
    updatePageTitle: (state, actions: PayloadAction<TPageTitle>) => {
      state.pageTitle = actions.payload.title;
    },
    updateRegionData: (state, actions: PayloadAction<Region>) => {
      state.regionData = { ...actions.payload };
    },
  },
});

export const { startProcess, endProcess, updateRegionData, updatePageTitle } = appSlide.actions;

export default appSlide.reducer;
